import React from "react";
import QuestionCard from "../components/QuestionCard";
import ResultCard from "../components/ResultCard";
import { connect } from "react-redux";
import Box from "@mui/material/Paper";

const CatNameGen = props => {
  const { status } = props;
  /*   return(
    status === 2 ? <ResultCard /> : <QuestionCard />
  );*/

  switch (status) {
    case 2:
    case 3:
      return (
        <Box
          sx={{
            display: "inline",
            boxShadow: 2,
            borderRadius: 2,
            "background-color": "#e7dccf",
            p: 1.5,
            m: 1,
            "margin-bottom": "5em",
          }}>
          <ResultCard petType="cat" />
        </Box>
      );
    default:
      return (
        <Box
          sx={{
            display: "inline",
            fontWeight: "bold",
            boxShadow: 1,
            borderRadius: 2,
            "background-color": "#e7dccf",
            p: 1.5,
            m: 0.5,
            "margin-bottom": "5em",
          }}>
          <QuestionCard petType="cat" />
        </Box>
      );
  }
};
const mapStateToProps = state => {
  return {
    ...state.quiz,
  };
};

export default connect(mapStateToProps, null)(CatNameGen);
